import React, { useReducer, useState} from 'react'
import { render } from 'react-dom'
import ReCAPTCHA from 'react-google-recaptcha'
import { WigWizardReducer } from '../reducers/WigWizardReducer'
import { User } from '../types/User'
import { WizardState } from '../types/WigWizard'
import { CameraIntro } from './CameraIntro'
import { Measure } from './Measure'


(function init() {
  const selectors = {
    startMeasurements: '[data-start-measurements]',
    cartWizard: '[data-cart-wizard]',
  }
  const cartWizardElement = document.querySelector(selectors.cartWizard);

  document.querySelector(selectors.startMeasurements)?.addEventListener('click', () =>
    render(<CartWizard />, cartWizardElement)
  )
})()

function CartWizard() {
  
  const selectors = {
    userData: '[data-customer-data]',
    frontImage: '[data-variant-id] img',
    startMeasurements: '[data-start-measurements]',
  }
  const user: User = JSON.parse(document.querySelector(selectors.userData).innerHTML)
  const initialState: WizardState = {
    steps: [{}, {}, {}, {}],
    active: 0,
    capSize: user.cap_size,
    laceTint: user.lace_tint,
    laceTintDescription: user.lace_tint_description,
    s3BucketFolder: user.s3_bucket_folder,
    frontImage: document.querySelector<HTMLImageElement>(selectors.frontImage)?.src,
    captchaCompleted: false
  }

  const [showIntro, setShowIntro] = useState(true);
  const [cameraVisible, setCameraVisible] = useState(false)
  const [state, dispatch] = useReducer(WigWizardReducer, initialState);


  return <>
    {showIntro && state.captchaCompleted &&
      <div className="fixed top-0 left-0 z-30 lg:top-1/2 lg:left-1/2 lg:-translate-x-2/4 lg:-translate-y-2/4 lg:px-4 lg:w-full pointer-events-none">
        <div className="bg-white lg:max-w-[1232px] lg:mx-auto w-screen lg:w-full h-screen lg:h-auto pointer-events-auto">
          <CameraIntro close={() => setShowIntro(false)} next={() => { dispatch({ type: 'StartCamera' }); setTimeout(() => { setShowIntro(false); setCameraVisible(true) }, 1000) }} />
        </div>
      </div>
    }

    {cameraVisible && state.captchaCompleted &&
      <div className="fixed top-0 left-0 bg-white w-screen h-screen z-20">
        <Measure setCameraVisible={setCameraVisible} state={state} dispatch={dispatch} user={user} />
      </div>
    }

    {showIntro && !state.captchaCompleted &&
      <div className="fixed top-0 left-0 w-full h-full bg-black/20 flex justify-center items-center z-40">
        <ReCAPTCHA onChange={() => dispatch({ type: 'CaptchaCompleted' })} sitekey="6LcVjZ8eAAAAACRYMvBrqxC-5O33MAgW7dUHJAGG" />
      </div>
    }
    <script type="text/javascript">
      window.tolstoyWidgetId="h5b8n01ejwdl2";
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://widget.gotolstoy.com/widget/widget.js";
      document.head.appendChild(s);
    </script>
  </>
}
